var _a;
let debugModeEnabled = process.env.NODE_ENV && process.env.NODE_ENV === 'development';
let portalTraceEnabled = debugModeEnabled && true;
if (!debugModeEnabled) {
    try {
        const debugFlag = localStorage.getItem('commandbar.debug');
        if (debugFlag === '1') {
            debugModeEnabled = true;
            portalTraceEnabled = false;
        }
        else if (debugFlag === '2') {
            debugModeEnabled = true;
            portalTraceEnabled = true;
        }
    }
    catch (err) { }
}
const frameName = (_a = process.env.REACT_APP_FRAME_NAME) !== null && _a !== void 0 ? _a : '_WIDGET_';
const prefix = ` [${frameName.toUpperCase()}] `;
const styledPrefix = `%c${prefix}`;
const log = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: lightgrey; color: black; display: block;')
    : () => {
        return;
    };
const debug = debugModeEnabled
    ? console.debug.bind(window.console, prefix)
    : () => {
        return;
    };
const info = debugModeEnabled
    ? console.info.bind(window.console, prefix)
    : () => {
        return;
    };
const warn = debugModeEnabled
    ? console.warn.bind(window.console, prefix)
    : () => {
        return;
    };
const error = debugModeEnabled
    ? console.error.bind(window.console, prefix)
    : () => {
        return;
    };
const red = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: red; color: white; display: block;')
    : () => {
        return;
    };
const green = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: green; color: white; display: block;')
    : () => {
        return;
    };
const blue = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: blue; color: white; display: block;')
    : () => {
        return;
    };
const orange = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: orange; color: white; display: block;')
    : () => {
        return;
    };
const yellow = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: yellow; color: white; display: block;')
    : () => {
        return;
    };
const purple = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: purple; color: white; display: block;')
    : () => {
        return;
    };
const black = debugModeEnabled
    ? console.log.bind(window.console, styledPrefix, 'background: black; color: white; display: block;')
    : () => {
        return;
    };
const portalsend = portalTraceEnabled
    ? console.log.bind(window.console, `%c ###SEND [${frameName.toUpperCase()}] `, 'background: darkcyan; color: black; display: block;')
    : () => {
        return;
    };
const portalreceive = portalTraceEnabled
    ? console.log.bind(window.console, `%c ###RECEIVE  [${frameName.toUpperCase()}] `, 'background: steelblue; color: black; display: block;')
    : () => {
        return;
    };
const Logger = {
    debug,
    log,
    info,
    warn,
    error,
    red,
    green,
    blue,
    orange,
    yellow,
    purple,
    black,
    portalsend,
    portalreceive,
};
export default Logger;
//# sourceMappingURL=data:application/json;base64,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